export const SET_REMINDERS = 'SET_REMINDERS';
export const SIGNED_IN = 'SIGNED_IN';
export const SET_COMPLETED = 'SET_COMPLETED';
